import React from 'react';
import cn from 'classnames';

type UILinkProps = {
  href: string
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void,
  className?: string
}

export default function UILink({
  className, href, onClick, children,
}: React.PropsWithChildren<UILinkProps>) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      event.preventDefault();
      onClick(event);
    }
  };

  return (
    <a href={href} className={cn('text-blue', className)}
      onClick={(e) => handleClick(e)}>{children}</a>
  );
}
